import React from "react";

export default function SectionHeading (props) {
    return (
        <div className="section-heading" 
            style={{
                color: props.color, 
                fontSize: props.font,
                margin: props.margin
            }}>
            {props.text}
        </div>
    )
}